export default "__VITE_ASSET__HfJm7Ubt__"